import { ZoomOptions } from './zoom-options';
import { IncludeInfo } from './include-info';
import { Expose, Type } from '@nts/std/serialization';
import { OutputDataOrderDto } from '../zoom/dto/output-data-order.dto';
import { IncludeInfoInterface, OutputDataOrderDtoInterface, ZoomAdvancedOptionsInterface } from '@nts/std/interfaces';

export class ZoomAdvancedOptions extends ZoomOptions implements ZoomAdvancedOptionsInterface {

    @Expose()
    @Type(() => IncludeInfo)
    includes: Array<IncludeInfoInterface>;

    @Expose()
    @Type(() => OutputDataOrderDto)
    outputDataOrderList: OutputDataOrderDtoInterface[];

    @Expose()
    allowEdit: boolean;

    constructor(zoomOptions?: ZoomOptions) {
        super();
        if (zoomOptions !== undefined) {
            this.filters = zoomOptions.filters;
            this.orderByPropertyNames = zoomOptions.orderByPropertyNames;
            this.skip = zoomOptions.skip;
            this.take = zoomOptions.take;
        }
    }

    firstOrDefaultIncludeInfo(predicate: any): IncludeInfoInterface {
        const listIncludes: Array<IncludeInfo> = [];
        const incls: Array<IncludeInfo> = this.flattenInclude(this.includes, listIncludes);

        return incls.find(predicate);
    }

    private flattenInclude(includes: IncludeInfoInterface[], incls: Array<IncludeInfoInterface>): Array<IncludeInfoInterface> {
        includes.forEach(i => {
            incls.push(i);
            if (i.includes && i.includes.length > 0) {
                this.flattenInclude(i.includes, incls);
            }
        });
        return incls;
    }


}
